var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66667H5.33333V0H0V6.66667ZM0 12H5.33333V8H0V12ZM6.66667 12H12V5.33333H6.66667V12ZM6.66667 0V4H12V0H6.66667Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardB);
export default __webpack_public_path__ + "static/media/dashboard_b.e309d16c5cc601859fee9d628a26b052.svg";
export { ForwardRef as ReactComponent };